import theme from '../../base';

const radioButton = {
  default: {
    bg: theme.colors.neutrals.gray800,
    border: theme.colors.neutrals.gray200,
    label: theme.colors.neutrals.gray200,
  },
  checked: {
    bg: theme.colors.blues.blue500,
    border: theme.colors.blues.blue500,
    foreground: theme.colors.blues.blue500,
  },
  disabled: {
    bg: theme.colors.neutrals.gray700,
    border: theme.colors.neutrals.gray500,
  },
  focus: {
    border: theme.colors.neutrals.gray800,
    offsetShadow: theme.colors.blues.blue300,
    insetShadow: theme.colors.neutrals.gray800,
  },
};

export default radioButton;
